export class CostDataFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "product",
            "baseName": "product",
            "type": "CostProductFilters",
            "format": ""
        },
        {
            "name": "usageType",
            "baseName": "usageType",
            "type": "UsageTypeFilters",
            "format": ""
        },
        {
            "name": "dsgStorageTier",
            "baseName": "dsgStorageTier",
            "type": "DsgStorageTierFilters",
            "format": ""
        },
        {
            "name": "dsgRequestType",
            "baseName": "dsgRequestType",
            "type": "DsgRequestTypeFilters",
            "format": ""
        },
        {
            "name": "dsgEnvironment",
            "baseName": "dsgEnvironment",
            "type": "DsgEnvironmentFilters",
            "format": ""
        },
        {
            "name": "dsgBucket",
            "baseName": "dsgBucket",
            "type": "DsgBucketFilters",
            "format": ""
        },
        {
            "name": "dsgRegion",
            "baseName": "dsgRegion",
            "type": "DsgRegionFilters",
            "format": ""
        },
        {
            "name": "accountId",
            "baseName": "accountId",
            "type": "CloudAccountIdFilters",
            "format": ""
        },
        {
            "name": "sourceAccountProviderId",
            "baseName": "sourceAccountProviderId",
            "type": "SourceAccountProviderIdFilters",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "ProjectIdFilters",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "CloudProviderFilters",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceTypeFilters",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "tagKeys",
            "baseName": "tagKeys",
            "type": "TagKeysFilters",
            "format": ""
        },
        {
            "name": "tagKeyValues",
            "baseName": "tagKeyValues",
            "type": "TagKeyValuesFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CostDataFilters.attributeTypeMap;
    }
    constructor() {
    }
}
